<template>
  <div class="share-page">
    <v-container v-if="loadding">
      <v-row justify="center" align="center">
        <v-col>
          <center>
            <h3>กำลังโหลดข้อมูล</h3>
            <p></p>
            <v-progress-circular
              :size="70"
              :width="5"
              color="success"
              indeterminate
            ></v-progress-circular>
          </center>
        </v-col>
      </v-row>
    </v-container>
    <v-lazy
      v-else
      v-model="isActive"
      :options="{
        threshold: 0.5,
      }"
      min-height="100"
      transition="fade-transition"
    >
      <div v-if="!noHave">
        <v-layout class="pb-6">
          <v-flex xs12 sm6 offset-sm3 class="mb-4">
            <v-card style="border-radius: 10px">
              <v-container
                fluid
                :style="
                  datalists.announcement_type === 'tor'
                    ? 'background: linear-gradient(to left, #062e5d 12%, #529ff8 100%);'
                    : 'background: linear-gradient(to left, #065d31 12%, #19a294 100%);'
                "
              >
                <v-layout>
                  <v-flex xs12 align-self-center>
                    <center>
                      <p style="font-size: 30px; color: white" class="mb-2">
                        {{ datalists.name_th.trim() }}
                      </p>
                      <span
                        v-if="datalists.announcement_type === 'tor'"
                        style="color: white; font-size: 20px"
                        ><p style="margin-bottom: 6px">ประกาศร่าง ToR</p></span
                      >
                      <span v-else style="color: white; font-size: 20px"
                        ><p style="margin-bottom: 6px">ประกาศเชิญชวน</p></span
                      >
                      <hr
                        style="
                          width: 30%;
                          height: 4px;
                          color: #ffc400;
                          background-color: #ffc400;
                          border: 1px solid #ffc400;
                          border-radius: 5px;
                          margin-bottom: 6px;
                        "
                      />
                      <span style="color: white; font-size: 20px">{{
                        datalists.project_code.trim()
                      }}</span>
                    </center>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-card-subtitle primary-title>
                <v-container style="padding: 0px" class="box-container">
                  <v-row>
                    <v-col class="pt-0">
                      <p class="mb-0" style="font-size: 15.5px">
                        <span class="ml-5"></span
                        >{{ datalists.project_name.trim() }}
                      </p>
                      <a
                        :href="datalists.download_link"
                        target="_blank"
                        style="font-size: 15.5px"
                      >
                        <u>เอกสารจัดซื้อจัดจ้าง [คลิก]</u>
                      </a>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <h3>หน่วยงาน</h3>
                      <p class="ml-1" style="font-size: 15.5px">
                        <a :href="datalists.institution_link" target="_blank"
                          >{{ datalists.institution.trim() }} [คลิก]</a
                        >
                      </p>
                    </v-col>
                  </v-row>
                  <v-row v-if="datalists.announcement_type === 'invite'">
                    <v-col>
                      <h3>เบอร์โทรหน่วยงาน</h3>
                      <p class="ml-1" style="font-size: 15.5px">
                        {{ datalists.institution_tall }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      datalists.announcement_type === 'invite' &&
                      datalists.location !== null
                    "
                  >
                    <v-col>
                      <h3>ตำเเหน่งหน้างาน</h3>
                      <v-hover>
                        <template v-slot:default="{ hover }">
                          <v-card class="mx-auto" max-width="344">
                            <v-img
                              lazy-src="../assets/location.png"
                              src="../assets/location.png"
                            ></v-img>

                            <v-fade-transition>
                              <v-overlay v-if="hover" absolute color="#036358">
                                <v-btn @click="openMap(datalists.location)"
                                  >เปิดเเผนที่คลิก</v-btn
                                >
                              </v-overlay>
                            </v-fade-transition>
                          </v-card>
                        </template>
                      </v-hover>
                    </v-col>
                  </v-row>
                  <v-row v-if="datalists.announcement_type === 'tor'">
                    <v-col>
                      <h3>วันที่เริ่ม - วันที่สิ้นสุดรับฟังคำวิจารณ์</h3>
                      <p style="font-size: 15.5px" class="ml-1">
                        {{ datalists.tor_date_start.replace(/-/g, " ") }} ถึง
                        {{ datalists.tor_date_end.replace(/-/g, " ") }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row
                    style="
                      background-color: #dc8006;
                      border-radius: 5px;
                      color: #ffffff;
                      margin: 0px;
                      margin-bottom: 16px;
                    "
                  >
                    <v-col style="padding-bottom: 0px">
                      <h3>ประเภทงาน</h3>
                    </v-col>
                    <v-col class="text-right" style="padding-bottom: 0px">
                      <p
                        style="font-size: 15.5px"
                        v-for="(item, i) in type_work"
                        :key="i"
                      >
                        {{ item }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <h3>งบประมาณโครงการ</h3>
                    </v-col>
                    <v-col class="text-right"
                      ><p style="font-size: 15.5px">
                        {{
                          datalists.expenditure
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        บาท
                      </p></v-col
                    >
                  </v-row>
                  <v-row>
                    <v-col>
                      <h3>ราคากลาง</h3>
                    </v-col>
                    <v-col class="text-right"
                      ><p style="font-size: 15.5px">
                        {{
                          datalists.middle_price
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        บาท
                      </p></v-col
                    >
                  </v-row>
                  <v-row v-if="datalists.announcement_type === 'invite'">
                    <v-col>
                      <h3>มูลค่างานประเภทเดียวกัน</h3>
                    </v-col>
                    <v-col class="text-right"
                      ><p style="font-size: 15.5px">
                        {{
                          datalists.same_price
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        บาท
                      </p></v-col
                    >
                  </v-row>
                  <v-row
                    v-if="datalists.announcement_type === 'invite'"
                    style="
                      background-color: #dc8006;
                      border-radius: 5px;
                      color: #ffffff;
                      margin: 0px;
                      margin-bottom: 16px;
                    "
                  >
                    <v-col style="padding-bottom: 0px">
                      <h3>ราคาซอง</h3>
                    </v-col>
                    <v-col class="text-right" style="padding-bottom: 0px">
                      <p>
                        {{
                          datalists.secret_price
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        บาท
                      </p>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="datalists.announcement_type === 'invite'"
                    style="
                      background-color: #dc8006;
                      border-radius: 5px;
                      color: #ffffff;
                      margin: 0px;
                      margin-bottom: 16px;
                    "
                  >
                    <v-col style="padding-bottom: 0px">
                      <h3>วันที่ยื่นซอง</h3>
                    </v-col>
                    <v-col class="text-right" style="padding-bottom: 0px">
                      <p>
                        {{ datalists.submission_date.replace(/-/g, " ") }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row v-if="datalists.announcement_type === 'invite'">
                    <v-col>
                      <h3>คุณสมบัติพิเศษ</h3>
                      <p class="ml-1" style="font-size: 15.5px">
                        {{ datalists.special_features }}
                      </p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-subtitle>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout class="pt-6">
          <v-flex xs12 sm6 offset-sm3 class="mb-4">
            <v-card style="border-radius: 10px">
              <v-container
                class="pb-0 pt-6"
                fluid
                style="background-color: #e14023"
              >
                <div style="background-color: #fef2f2">
                  <v-row justify="center" align="center">
                    <v-col class="text-center pt-4 pb-1"
                      ><span style="color: #e14023; font-size: 16px"
                        >คุณสามารถได้รับการสนับสนุนสูงสุดถึง</span
                      ></v-col
                    >
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="text-center pt-1 pb-1"
                      ><span
                        style="
                          color: #e14023;
                          font-weight: bold;
                          font-size: 36px;
                        "
                        >60 %</span
                      ></v-col
                    >
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="text-center pt-1 pb-2"
                      ><span style="color: #e14023; font-size: 16px"
                        >มูลค่างานที่คุณชนะ</span
                      ></v-col
                    >
                  </v-row>
                </div>
              </v-container>
              <v-card-subtitle primary-title>
                <v-container style="padding: 0px" class="box-container">
                  <v-row justify="center" align="center">
                    <v-col class="text-center pb-0 pt-4">
                      <span
                        class="separator"
                        style="color: #a1a1a1; font-size: 16px"
                        >ผลประโยชน์ที่ได้รับ</span
                      ></v-col
                    >
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="text-center pb-0 pt-0">
                      <v-row justify="center" align="center">
                        <v-col class="text-left" cols="3" sm="3">
                          <v-img
                            lazy-src="../assets/1.png"
                            src="../assets/1.png"
                          ></v-img>
                        </v-col>
                        <v-col class="text-left">
                          <h4>วัสดุซื้อก่อนจ่ายทีหลัง</h4>
                          <span style="font-size: 13px"
                            >เลือกได้ว่าจะจ่ายเครดิตหรือหลังเสร็จงานเเล้ว</span
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="text-center pb-0 pt-0">
                      <v-row justify="center" align="center">
                        <v-col class="text-left" cols="3" sm="3">
                          <v-img
                            lazy-src="../assets/2.png"
                            src="../assets/2.png"
                          ></v-img>
                        </v-col>
                        <v-col class="text-left">
                          <h4>เงินทุน</h4>
                          <span style="font-size: 13px">
                            เงินทุนสนับสนุนสูงสุด 30% ของมูลค่างาน
                            โดยไม่ต้องมีหลักทรัพย์
                          </span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="text-center pb-0 pt-0">
                      <v-row justify="center" align="center">
                        <v-col class="text-left" cols="3" sm="3">
                          <v-img
                            lazy-src="../assets/3.png"
                            src="../assets/3.png"
                          ></v-img>
                        </v-col>
                        <v-col class="text-left">
                          <h4>สู้ไปด้วยกัน</h4>
                          <span style="font-size: 13px">
                            ขยายงานได้ไร้กังวล โดยไม่ต้องใช้หลักประกัน
                          </span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="text-center pb-0 pt-0">
                      <span
                        class="separator"
                        style="color: #a1a1a1; font-size: 16px"
                      >
                        เคเอ็มพีพาร์ทเนอร์ทำงานอย่างไร</span
                      >
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="text-center pb-0 pt-0">
                      <v-row justify="center" align="center">
                        <v-col class="text-left" cols="3" sm="3">
                          <v-img
                            lazy-src="../assets/4.png"
                            src="../assets/4.png"
                          ></v-img>
                        </v-col>
                        <v-col class="text-left">
                          <h4>การบริการ</h4>
                          <span style="font-size: 13px">
                            บริการถึงที่ คุณไม่ต้องเดินทางมา
                          </span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="text-center pb-0 pt-0">
                      <v-row justify="center" align="center">
                        <v-col class="text-left" cols="3" sm="3">
                          <v-img
                            lazy-src="../assets/5.png"
                            src="../assets/5.png"
                          ></v-img>
                        </v-col>
                        <v-col class="text-left">
                          <h4>การเติบโต</h4>
                          <span style="font-size: 13px">
                            เติบโตเเซงใคร เพราะเราเคียงข้างกัน
                          </span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="text-center pb-2 pt-2">
                      <span
                        class="separator"
                        style="color: #a1a1a1; font-size: 16px"
                      >
                        รู้จักเราเพิ่มเติม</span
                      >
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="text-center">
                      <span>เราทำให้ผู้รับเหมา ไม่ต้องไปง้อเเบงค์เเล้ว</span>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col class="text-center">
                      <v-btn color="success" x-large @click="addLine()">
                        <v-img
                          max-width="50"
                          lazy-src="../assets/7.png"
                          src="../assets/7.png"
                        ></v-img>
                        <span class="ml-3">เพิ่มเพื่อน</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-subtitle>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
      <div v-else>
        <v-layout class="pb-6">
          <v-flex xs12 sm6 offset-sm3 class="mb-4">
            <v-card style="border-radius: 10px">
              <v-container>
                <v-row justify="center" align="center">
                  <v-col class="text-center">
                    <h3>ไม่พบข้อมูล</h3>
                  </v-col>
                </v-row>
              </v-container>
            </v-card></v-flex
          ></v-layout
        >
      </div>
    </v-lazy>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    datalists: [],
    type_work: [],
    loadding: true,
    isActive: false,
    noHave: false,
  }),
  mounted() {
    if (localStorage.getItem("username") !== null) {
      if (localStorage.getItem("role") !== "Admin") {
        alert("คุณไม่มีสิทธิ์เข้าถึงหน้านี้");
        this.$router.push("/login");
      }
      //----------
    }
   
    axios
      .post(this.api + "/showprojectuser", {
        project_code: this.$route.params.id,
      })
      .then((res) => {
        if (res.data.status === false) {
          this.noHave = true;
          this.loadding = false;
        } else {
          this.noHave = false;
          this.datalists = res.data.response[0];
          axios
            .post(this.api + "/get/typejob", {
              type: this.datalists.type_of_work_id,
            })
            .then((res) => {
              this.type_work = res.data.msg.split(",");
              setTimeout(() => {
                this.loadding = false;
              }, 1000);
            });
        }
      });
  },
  methods: {
    addLine() {
      window.open("https://line.me/R/ti/p/%40wuj8570i", "_blank");
    },
    openMap(location) {
      window.open(location, "_blank");
    },
  },
};
//------------------เชิญชวน-------------------------------เชิญชวน-------------------------------------------เชิญชวน--------------------------เชิญชวน---------------------------------------เชิญชวน----------------------------------เชิญชวน---
</script>

<style>
.share-page {
  margin: 3%;
}
.box-container {
  color: black;
}
.share-page .separator {
  display: flex;
  align-items: center;
  text-align: center;
}
.share-page .separator::before,
.share-page .separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #a1a1a1;
}
.share-page .separator::before {
  margin-right: 0.8em;
  margin-left: 2em;
}
.share-page .separator::after {
  margin-left: 0.8em;
  margin-right: 2em;
}
</style>
